import type { NavItem } from '../types/content'

export const site = {
  driver: 'Em Whell',
  team: 'Em Whell Motorsport',
  number: '7',
  className: 'SSA Production Sedan',
  location: 'Toowoomba, Queensland',
  phoneDisplay: '0437 226 166',
  phoneHref: '+61437226166',
  email: 'hello@emwhellmotorsport.com',
  facebook: 'https://www.facebook.com/profile.php?id=100063479134022',
}

export const navigation: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Em', to: '/about' },
  { label: 'Racing', to: '/racing' },
  { label: 'Partners', to: '/partners' },
  // { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' },
]
